export const CURRENT_USER_BLOCKED = 'CURRENT_USER_BLOCKED';
export const CURRENT_USER_UNBLOCKED = 'CURRENT_USER_UNBLOCKED';

export const BLOCK_TYPE_24H = '24h';
export const BLOCK_TYPE_PERMANENT = 'permanent';


// WEBPACK FOOTER //
// ./src/constants/block.js